<template>
	<div class=''>
		<el-row class='gPageBorder  gPdTB' style=''>
			<el-col :span='12'>
				<el-form class='gShowLeftForm' label-position='left' label-width="30%">
					<el-form-item :label="$t('app_serialnumber') ">
						{{ authDetail.terminalNo}}
					</el-form-item>
				</el-form>
			</el-col>

			<el-col :span='12'>
				<el-form class='gShowRightForm' label-position='left' label-width="30%">
					<el-form-item :label="$t('app_model') ">
						{{ authDetail.modelName}}
					</el-form-item>
				</el-form>
			</el-col>

			<el-col :span='12'>
				<el-form class='gShowLeftForm' label-position='left' label-width="30%">
					<el-form-item :label="$t('lin_global.status') ">
						<el-tag  :type="authDetail.status == 1 ? 'success' : 'danger'">{{ formatStatus(authDetail.status)}}</el-tag>
					</el-form-item>
				</el-form>
			</el-col>

			<el-col :span='12'>
				<el-form class='gShowRightForm' label-position='left' label-width="30%">
					<el-form-item :label="$t('app_authcode') ">
						{{ authDetail.activationCode}}
					</el-form-item>
				</el-form>
			</el-col>
		</el-row>

		<div class="gTopMg gPageBorder">
			<el-row style="margin-bottom:24px">
			
				<el-col :span="12" style="">
					<el-button  class='gSgLeftBtn' type="primary" @click="getList(1)">
						{{$t('lin_global.shuaxin')}}
					</el-button>
				</el-col>
			
				
			
			
			</el-row>


			<el-table :data="arrdata" border>
				<el-table-column prop="optTime" :label="$t('app_udtime')">
				</el-table-column>
				<el-table-column prop="status" :label="$t('app_authstat')" :formatter="formatListStatus" :show-overflow-tooltip="true" ></el-table-column>
			</el-table>

		</div>

	</div>
</template>
<script>
	import axios from 'axios'
	import {
		baseurl
	} from '../../api/url'
	export default {
		data() {
			return {
				currentPage: 1,
				pageSize: 10,
				totalRecords: 0,
				certinfo: {},
				arrdata: [],
				authDetail:{
				},
				status_list:[
					{
						vl:"0"
					},
					{
						vl: '1',
						lb: this.$t('auth_status_list.status_1')
					},
					{
						vl: '2',
						lb: this.$t('auth_status_list.status_2')
					},
					{
						vl: '3',
						lb: this.$t('auth_status_list.status_3')
					},
					{
						vl: '4',
						lb: this.$t('auth_status_list.status_4')
					},
					{
						vl: '5',
						lb: this.$t('auth_status_list.status_5')
					},
					{
						vl: '6',
						lb: this.$t('auth_status_list.status_6')
					}
				]
			}
		},
		created() {
			this.getDetail();
			this.getList(1);
		},
		methods: {
			getList: function(page) {
				this.currentPage = page;
				console.log(this.$route.query);
				var params = {
					terminalNo: this.$route.query.terminalNo,
					page: page,
					rows: this.pageSize,
				}
				
				axios.post(`${baseurl}/terminal_auth/authorizationDetail.do`, params).then(res => {
					console.log("数据别表");
					if (res.data.status == 200) {
						this.authDetail = res.data.data;
						this.arrdata = this.authDetail.dataList
					} else {
						this.$message.error(res.data.message)
					}

				})
			},
			
			formatListStatus: function(row, column) {
				let result = row.status ? this.status_list[row.status].lb : ""
				return result
			},
			formatStatus: function(status) {
				return status == "1" ?	this.$t('lin_global.normal') : this.$t('app_selfDestroy') ;
			},
			handleSizeChange: function(val) {
				this.pageSize = val
				this.getList(this.currentPage)
			},
			handleCurrentChange: function(val) {
				this.currentPage = val
				this.getList(this.currentPage)
			},
			getDetail: function() {
				var certId = this.$route.params.id;
				var params = {
					certificateId: certId
				};
				axios.post(`${baseurl}/cer/getById.do`, params).then(res => {
					console.log(res.data);
					if (res.data.status == 200) {
						this.certinfo = res.data.data;
					}
				})
			},
		}
	}
</script>


// WEBPACK FOOTER //
// authorizeDetail.vue?01410da0